import { motion } from "framer-motion";
import { LumenLogo } from "../LumenLogo";
import { Heart } from "lucide-react";

export const Footer = () => {
  return (
    <footer 
      className="py-12 bg-gradient-to-b from-emerald-50 to-emerald-100/50"
      data-testid="footer"
    >
      <div className="lumen-container">
        <div className="max-w-4xl mx-auto">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <LumenLogo size="md" animated={false} />
          </div>

          {/* Ethical manifesto */}
          <motion.div
            className="text-center mb-8"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-cormorant text-lg text-text-muted italic max-w-xl mx-auto">
              "L'IA éthique pour les praticiens qui veulent rester alignés 
              tout en développant leur visibilité."
            </p>
          </motion.div>

          {/* Divider */}
          <div className="w-20 h-px bg-gradient-to-r from-transparent via-emerald-300 to-transparent mx-auto mb-8" />

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm font-manrope">
            <a 
              href="#" 
              className="text-text-muted hover:text-emerald-700 transition-colors duration-300"
              data-testid="footer-link-mentions"
            >
              Mentions légales
            </a>
            <a 
              href="#" 
              className="text-text-muted hover:text-emerald-700 transition-colors duration-300"
              data-testid="footer-link-cgv"
            >
              CGV
            </a>
            <a 
              href="#" 
              className="text-text-muted hover:text-emerald-700 transition-colors duration-300"
              data-testid="footer-link-contact"
            >
              Contact
            </a>
          </div>

          {/* Copyright */}
          <div className="text-center">
            <p className="font-manrope text-sm text-text-muted flex items-center justify-center gap-2">
              Créé avec <Heart className="w-4 h-4 text-emerald-500" /> par LUMEN
            </p>
            <p className="font-manrope text-xs text-text-muted/60 mt-2">
              © {new Date().getFullYear()} LUMEN. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
